<template>
  <div class="being-matched">
    <!-- <div class="header">
      <div class="left">
        今日剩餘 <span class="times">{{ AnonymousCallProvider.times }}</span> 次
      </div>
      <SettingVue></SettingVue>
    </div> -->
    <div class="content no-scrollbar">
      <!-- <div class="title">暫時無人接聽</div> -->
      <!-- <img
        class="sex-image"
        src="./images/female.png"
        alt=""
        v-show="AnonymousCallProvider.matchGender === 'female'"
      />
      <img
        class="sex-image"
        src="./images/male.png"
        alt=""
        v-show="AnonymousCallProvider.matchGender === 'male'"
      />
      <img
        class="sex-image"
        src="./images/random.png"
        alt=""
        v-show="AnonymousCallProvider.matchGender === 'random'"
      /> -->
      <div class="tip">尚未找到有緣人，請稍後再嘗試撥打</div>
      <button class="btn-retry" type="button" @click="retry()">
        返回
      </button>
    </div>
  </div>
</template>
<script>
// import SettingVue from './setting.vue';
import AnonymousCallProvider from './anonymousCall';
export default {
  name: 'BeingMatched',
  components: {
    // SettingVue
  },
  data() {
    return { AnonymousCallProvider };
  },
  watch: {},
  computed: {},
  methods: {
    cancel() {
      this.$emit('onCancel');
    },
    retry() {
      this.$emit('onBack');
    }
  }
};
</script>
<style lang="scss" scoped>
.being-matched {
  color: white;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  line-height: 1.5;
  position: relative;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    margin-top: 20px;
    flex: none;
    position: relative;
    width: 100%;
    padding: 0 24px;
  }
  .left {
    color: rgba(255, 255, 255, 0.55);
    .times {
      color: #ffffff;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: auto;
    height: 1px;
    overflow: auto;
  }
  .title {
    color: #ffffff;
    font-size: 33px;
    font-weight: 500;
    margin-bottom: 67px;
  }
  .sex-image {
    width: auto;
    height: 200px;
    position: relative;
    object-fit: cover;
    margin-bottom: 100px;
  }
  .btn-retry {
    border-radius: 1197.19px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.35);
    border-width: 2.4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 126px;
    height: 44px;
    color: rgba(255, 255, 255, 0.77);
    margin-bottom: 60px;
    flex: none;
  }
  .tip {
    color: rgba(255, 255, 255, 0.77);
    font-size: 15px;
    margin-bottom: 40px;
  }
}
</style>
